import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { Form, withFormik } from 'formik';
import compose from 'lodash/fp/compose';

import { withHigherOrderComponent } from '../../../../../../shared/components/with-higher-order-component/with-higher-order-component';
import { useNoSubmit } from '../../../../../../shared/hooks/use-no-submit/use-no-submit.hook';
import Filter from '../../../../../shared/components/filter/Filter';
import DateDropdown from './components/date-dropdown/date-dropdown';
import IsFeaturedDropdown from './components/is-featured-dropdown';
import PlatformsDropdown from './components/platforms-dropdown';
import RatingsDropdown from './components/ratings-dropdown';
import ReleasesDropdown from './components/releases-dropdown';
import VehiclesDropdown from './components/vehicles-dropdown';
import { ReviewFiltersFormikModel } from './models/review-filters-formik.model';
import { ReviewFiltersProps } from './types/review-filters.props';

const ReviewsFiltersContainer: FunctionComponent<ReviewFiltersProps> = (
  props: PropsWithChildren<ReviewFiltersProps>
): ReactElement => {
  const { children, handleSubmit } = props;

  return (
    <Form onSubmit={handleSubmit}>
      <Filter>{children}</Filter>
    </Form>
  );
};

export default withFormik<any, ReviewFiltersFormikModel>({
  handleSubmit: useNoSubmit(),
})(
  compose(
    withHigherOrderComponent(DateDropdown),
    withHigherOrderComponent(RatingsDropdown),
    withHigherOrderComponent(VehiclesDropdown),
    withHigherOrderComponent(ReleasesDropdown),
    withHigherOrderComponent(PlatformsDropdown),
    withHigherOrderComponent(IsFeaturedDropdown)
  )(ReviewsFiltersContainer)
);
